import { IconType } from "react-icons";
import { FaFile, FaFileAlt, FaUser } from "react-icons/fa";
import { IoMdSchool } from "react-icons/io";
import {
  MdDashboard,
  MdPeople,
  MdShoppingCart,
  MdArticle,
  MdInventory,
  MdAssessment,
  MdPayments,
  MdLocalOffer,
  MdWeb,
  MdSettings,
  MdMenuBook,
  MdCategory,
  MdLayers,
  MdCollectionsBookmark,
  MdShowChart,
  MdOutlineLibraryBooks,
  MdGroups,
  MdToggleOn,
} from "react-icons/md";
import { useAuth } from "./hooks/useAuth";
import { useEffect, useState } from "react";
import { Module } from "./models/UserRole.model";
import { moduleRoutes } from "./Config/moduleRoutes";

type NavItemTypeWithoutChild = {
  label: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const navigation: NavItemType[] = [
  {
    label: "Dashboard",
    icon: MdDashboard,
    path: "/dashboard",
  },
  {
    label: "Admin",
    icon: MdPeople,
    path: "/admin",
  },

  // {
  //   label: "Order",
  //   icon: RxDashboard,
  //   path: "/offline-order",
  // },
  {
    label: "Order",
    icon: MdShoppingCart,
    path: "/order",
  },
  // {
  //   label: "Future Purchase",
  //   icon: MdSchedule,
  //   path: "/future-purchase",
  // },
  {
    label: "Blog",
    icon: MdArticle,
    path: "/blog",
  },
  {
    label: "Products Configuration",
    icon: MdInventory,
    children: [
      {
        label: "Products",
        icon: MdInventory,
        path: "/products",
      },
      {
        label: "Product Excel Logs",
        icon: MdAssessment,
        path: "/product/excel-logs",
      },
    ],
  },
  // {
  //   label: "Franchise",
  //   icon: MdBusiness,
  //   path: "/franchise",
  // },
  // {
  //   label: "Student",
  //   icon: MdSchool,
  //   path: "/student",
  // },
  // {
  //   label: "Advance Payment",
  //   icon: MdAccountBalanceWallet,
  //   path: "/advance-payment",
  // },
  {
    label: "Transactions",
    icon: MdPayments,
    path: "/transaction",
  },
  {
    label: "Users",
    icon: MdPeople,
    path: "/user",
  },
  // {
  //   label: "Dues",
  //   icon: MdReceiptLong,
  //   path: "/dues",
  // },
  // {
  //   label: "Drawer",
  //   icon: MdDns,
  //   path: "/drawer",
  // },
  {
    label: "Coupons",
    icon: MdLocalOffer,
    path: "/coupons",
  },
  {
    label: "CMS",
    icon: MdWeb,
    path: "/cms",
  },
  {
    label: "Configuration",
    icon: MdSettings,
    children: [
      // {
      //   label: "Payment Mode",
      //   path: "/payment-mode",
      //   icon: FaMoneyBill,
      // },
      {
        label: "Category",
        path: "/category",
        icon: MdCategory,
      },
      {
        label: "Level",
        path: "/level",
        icon: MdShowChart,
      },
      {
        label: "Subject",
        path: "/subject",
        icon: MdOutlineLibraryBooks,
      },
      {
        label: "Institute",
        path: "/institute",
        icon: IoMdSchool,
      },
      {
        label: "Faculty",
        path: "/faculty",
        icon: MdGroups,
      },
      {
        label: "Course",
        path: "/course",
        icon: MdMenuBook,
      },

      {
        label: "Mode",
        path: "/mode",
        icon: MdToggleOn,
      },
      {
        label: "Syllabus",
        path: "/syllabus",
        icon: MdCollectionsBookmark,
      },
      {
        label: "Batch Type",
        path: "/batch-type",
        icon: MdCollectionsBookmark,
      },
      {
        label: "Module",
        path: "/module",
        icon: MdLayers,
      },
      {
        label: "User Role",
        path: "/user-role",
        icon: FaUser,
      },
      {
        label: "Group",
        path: "/group",
        icon: MdGroups,
      },

      {
        label: "File Manager",
        path: "/file-manager",
        icon: FaFileAlt,
      },

      // {
      //   label: "Course Type",
      //   path: "/course-type",
      //   icon: MdLibraryAdd,
      // },
      // {
      //   label: "Attempt",
      //   path: "/attempt",
      //   icon: MdAssignmentTurnedIn,
      // },
    ],
  },
];

// src/config/navigation.ts
export const useNavigationConfig = (): NavItemType[] => {
  const { getAvailableModules, isLoading } = useAuth();
  const [filteredNavigation, setFilteredNavigation] = useState<NavItemType[]>(
    []
  );
  useEffect(() => {
    if (!isLoading) {
      const availableModules: Module[] = getAvailableModules();

      const filtered = navigation
        .map((navItem) => {
          // Direct route
          if (navItem.path) {
            const moduleId = moduleRoutes[navItem.path];
            const hasAccess = availableModules.some(
              (m) => m.moduleId === moduleId
            );
            return hasAccess ? navItem : null;
          }

          // With children
          if (navItem.children) {
            const allowedChildren = navItem.children.filter((child) => {
              const moduleId = moduleRoutes[child.path];
              return availableModules.some((m) => m.moduleId === moduleId);
            });

            if (allowedChildren.length > 0) {
              return { ...navItem, children: allowedChildren };
            }
          }

          return null;
        })
        .filter(Boolean) as NavItemType[];

      setFilteredNavigation(filtered);
    }
  }, [isLoading]);

  return isLoading ? [] : filteredNavigation;
};
